import { useCommandCenterBadges } from "@/hooks/command-center/use-command-center-badges";
import { COMMAND_CENTER_COPY as copy } from "./command-center-copy";

/** The unread pill and the mention dot on the sidebar item "Centro de comando". */
export function CommandCenterNavBadge() {
  const { unread, mentions } = useCommandCenterBadges();
  if (unread === 0 && mentions === 0) return null;

  return (
    <span className="ml-auto flex items-center gap-1 group-data-[collapsible=icon]:hidden">
      {mentions > 0 ? (
        <span
          role="img"
          aria-label={copy.mentionDotLabel}
          className="h-2 w-2 rounded-full bg-brand"
        />
      ) : null}
      {unread > 0 ? (
        <span
          aria-label={copy.unreadBadgeLabel(unread)}
          className="rounded-full bg-app-warning px-1.5 text-[11px] font-semibold text-app-fg-strong"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      ) : null}
    </span>
  );
}
